import { Injectable } from '@angular/core';
import firebase from 'firebase/compat';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Router } from '@angular/router';
import { FirebaseFunctionsService } from './firebase-functions.service';


@Injectable({
  providedIn: 'root'
})
export class AuthServicesService {

  constructor(private auth:AngularFireAuth, private afs: FirebaseFunctionsService, private router: Router) { }
  
  getUserUid(){
    return this.auth.authState.subscribe( res => res.uid)
  }
  isAuthenticated() {
    const uid = sessionStorage.getItem('userId');
    return (typeof uid == 'string') ? true: false;
  }
  isAdmin(){
    const typeUser = sessionStorage.getItem('userType');
    return (typeUser == 'administrateur') ? true: false;
  }
  loginUser(email:string,password:string): Promise<firebase.auth.UserCredential> {
    return this.auth.signInWithEmailAndPassword(email, password);
  }
  signOut(): Promise<void>{
    return this.auth.signOut();
  }
  resetPassword(email:string): Promise<void> {
    return this.auth.sendPasswordResetEmail(email);
  }  
}